<template>
  <transition name="modal" appear>
    <div class="modal" body-scroll-lock-ignore>
      <div class="modal-window">
        <div class="modal-content">
          <div v-if="header" class="modal-header">
            <h2 class="modal-heading"><slot name="header" /></h2>
            <button :class="headerCloseLinkClass" type="button" @click="closeModal($event)">
              <svg
                class="icon"
                xmlns="http://www.w3.org/2000/svg"
                width="13.261"
                height="13.26"
                viewBox="0 0 13.261 13.26"
              >
                <g transform="translate(3.671 -2.369) rotate(45)">
                  <line
                    x2="16.752"
                    transform="translate(8.456 -4.106) rotate(90)"
                    fill="none"
                    stroke-width="2"
                  />
                  <line
                    x2="16.752"
                    transform="translate(0.079 4.271)"
                    fill="none"
                    stroke-width="2"
                  />
                </g>
              </svg>
              <span v-if="bookingHeader">ウィンドウを閉じる（予約されません)</span>
              <span v-else class="close-text">{{ $t('modal.close') }}</span>
            </button>
          </div>
          <div v-else>
            <slot name="custom-header" />
          </div>
          <div class="modal-body">
            <slot />
          </div>
          <div v-if="footer" class="modal-footer">
            <slot name="footer" />
          </div>
        </div>
      </div>
      <div class="modal-mask" @click="closeModal($event)" />
    </div>
  </transition>
</template>

<script>
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
export default {
  props: {
    header: {
      type: Boolean,
      required: false,
      default: false
    },
    footer: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    notification: {
      type: String,
      required: false,
      default: ''
    },
    notificationHeader: {
      type: Boolean,
      required: false,
      default: false
    },
    isVisible: {
      type: Boolean,
      required: false,
      default: false
    },
    modalType: {
      type: String,
      required: false,
      default: ''
    },
    bookingHeader: {
      type: Boolean,
      default: false
    },
    isModalSticky: {
      type: Boolean,
      default: false
    },
    headerCloseLinkClass: {
      type: String,
      default: 'modal-text-close'
    }
  },
  mounted() {
    if (this.modalType !== 'show') {
      this.modalBackgroundFixed();
    }
  },
  updated() {
    if (this.isVisible) {
      this.modalBackgroundFixed();
    }
  },
  methods: {
    /**
     * モーダル表示時にモーダルの後ろを固定するための処理
     */
    modalBackgroundFixed() {
      const modal = document.querySelector('.modal');
      disableBodyScroll(modal, {
        allowTouchMove: el => {
          while (el && el !== document.body) {
            if (el.getAttribute('body-scroll-lock-ignore') !== null) {
              return true;
            }
            el = el.parentElement;
          }
        }
      });
    },
    closeModal(event) {
      // execute for modal-mask interaction only
      if (event.target.classList.contains('modal-mask')) {
        this.$emit('mask-modal');
      }
      // execute for header modal-text-close interaction only
      if (event.target.classList.contains('close-text')) {
        if (event.target.parentNode.classList.contains('disabled')) {
          // prevent modal closing if we have link disabled
          return;
        } else {
          this.$emit('header-close-modal');
        }
      }

      // DO NOT close modal if the backdrop/mask is clicked and modal is STICKY 
      if (this.isModalSticky && event.target.classList.contains('modal-mask')) {
        return;
      }

      this.$emit('close-modal');
      clearAllBodyScrollLocks();
    }
  }
};
</script>

<style lang="scss" src="@/assets/scss/modal.scss" />
